module.exports = __webpack_public_path__ + "img/error.a8a20861.svg";